/**
 * Payment constants
 */

export enum GatewayType {
  STRIPE = "stripe",
}

export enum BillingAlertStatus {
  CURRENT = "current",
  WARNING = "warning",
  CRITICAL = "critical",
  SUSPENDED = "suspended",
}

/** Matches product.interval_unit on the backend. */
export enum IntervalUnit {
  DAY = "day",
  MONTH = "month",
  YEAR = "year",
}

export enum BillingCycleType {
  ONE_TIME = "one_time",
  MONTHLY = "monthly",
  YEARLY = "yearly",
}

/** Matches credits.balance_source on the backend. */
export enum CreditBalanceSource {
  SUBSCRIPTION_PERIOD = "subscription_period",
  ROLLOVER = "rollover",
  TOP_UP = "top_up",
}

export class CurrencyConstants {
  /** Tier fixed_amount and amount_per_credit are integers at this many minor units per currency unit. */
  static readonly MINOR_UNITS_PER_CURRENCY_UNIT = 1000;
}
